module.exports = __webpack_public_path__ + "img/icone-seta-lateral.d476852a.svg";